module.exports = __webpack_public_path__ + "img/Module-Div-Wireframes.b7c868ca.svg";